<template>
  <div>
    <div v-if="!pageIndexApiDataIsLoading">
      <company-licence-component/>

      <div class="row">
        <div class="col-md-12 m-b-0">
          <router-link class="btn btn-white m-r-5" to="/monitoring"><i class="fa fa-tv fa-fw fa-lg"></i></router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/prospection"><i class="fa fa-map fa-fw fa-lg"></i>
            Prospection
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/sales"><i
              class="fa fa-chart-bar fa-chart-bar fa-lg"></i> Vente &amp; Facturation
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/vaults"><i class="fa fa-dollar-sign fa-fw fa-lg"></i>
            Caisse &amp; Dépenses
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/scm"><i
              class="fa fa-shopping-basket fa-fw fa-lg"></i> Appro. &amp; Achats
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/production"><i
              class="fa fa fa-flask fa-fw fa-lg"></i> Usine &amp; Production
          </router-link>
          <router-link class="btn btn-white m-r-5 text-orange" to="/monitoring/stock"><i
              class="fa fa-cube fa-fw fa-lg text-orange"></i> Stock &amp; Inventaires
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/admin"><i class="fa fa-cogs fa-fw fa-lg"></i> Console
            Admin
          </router-link>
        </div>
      </div>

      <!--<h1 class="page-header">Centre de controle  <small class="lead">.</small></h1>-->
      <hr class="bg-grey-lighter"/>

      <div class="row m-b-5">
        <div class="col-md-12 m-b-0">
          <router-link class="btn btn-white m-r-5" to="/monitoring/stock"><i class="fa fa-chart-bar fa-fw fa-lg"></i>
          </router-link>
          <router-link class="btn btn-white m-r-5 text-orange"
                       to="/monitoring/stock/stock-periodic-report-per-warehouse"><i
              class="fa fa-calendar fa-fw fa-lg text-orange"></i> Mouvements de stock &amp; Inventaires
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/stock/stock-orders"><i
              class="fa fa-exchange-alt fa-fw fa-lg"></i> Entrées/Sorties Libres
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/stock/stock-orders-debit"><i
              class="fa fa-exclamation-triangle fa-fw fa-lg"></i> Sorties Spéciales
          </router-link>
        </div>
      </div>

      <div class="row m-b-5">
        <div class="col-md-12 m-b-0">
          <router-link class="btn btn-white m-r-5 text-orange"
                       to="/monitoring/stock/stock-periodic-report-per-warehouse"><i
              class="fa fa-cubes fa-fw fa-lg text-orange"></i> Mouvements de stock &amp; Inventaires
          </router-link>
          <router-link class="btn btn-white m-r-5" to="/monitoring/stock/stock-periodic-report-per-warehouse-product"><i
              class="fa fa-history fa-fw fa-lg"></i> Historique des mouvements
          </router-link>
        </div>
      </div>

      <div v-if="pageIndexApiData != null">
        <div class="row text-right m-b-5">
          <div class="col-12">
            <a href="#" class="btn btn-dark m-l-5" @click="$bvModal.show('formModal')"><i
                class="fa fa-filter fa-fw fa-lg"></i></a>
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-if="queryApiData != null">
            <div class="row">
              <div class="col-12">
                <div class="invoice">
                  <!-- begin invoice-company -->
                  <div class="invoice-company">
                                            <span class="pull-right hidden-print">
                                                <a :href="queryApiData.document_url_pdf"
                                                   target="_blank" class="btn btn-sm btn-white m-b-10 mr-2"
                                                   v-if="queryApiData.document_url_pdf != null"><i
                                                    class="fa fa-file-pdf text-danger fa-fw fa-lg"></i> PDF</a>
                                            </span>
                    <h1>{{ queryApiData.warehouse_name }} <br/>
                      <small class="lead">Mouvements de stock &amp; Inventaires du {{ queryApiData.date_from }} au
                        {{ queryApiData.date_to }}</small>
                    </h1>
                  </div>
                  <!-- end invoice-company -->

                  <!-- begin invoice-content -->
                  <div class="invoice-content">
                    <div id="my-accordion" class="accordion">
                      <b-card no-body>
                        <b-card-header header-tag="header" class="card-header text-black pointer-cursor"
                                       v-b-toggle.accordion1>
                          <h2><i class="fa fa-arrow-circle-down text-orange"></i> Mouvements de stock</h2>
                        </b-card-header>
                        <b-collapse id="accordion1" accordion="my-accordion" visible>
                          <b-card-body>
                            <h3 class="m-t-10"><i class="fa fa-arrow-circle-right text-orange"></i> Mouvements</h3>
                            <b-tabs nav-class="nav-tabs-inverse" nav-wrapper-class="nav nav-tabs">
                              <b-tab active>
                                <template slot="title">
                                  <span class="d-sm-none">Résumé</span>
                                  <span class="d-sm-block d-none">Résumé <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_summary_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">OUVERTURE</th>
                                      <th class="text-center">TOTAL ENTREES</th>
                                      <th class="text-center">TOTAL SORTIES</th>
                                      <th class="text-right">CLOTURE</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_summary"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.balance_before|formatDecimalNumber }}</b></td>
                                      <td class="text-center"><b>{{ item.total_in|formatDecimalNumber }}</b></td>
                                      <td class="text-center"><b>{{ item.total_out|formatDecimalNumber }}</b></td>
                                      <td class="text-right"><b>{{ item.balance_after|formatDecimalNumber }}</b></td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Entrées Libres</span>
                                  <span class="d-sm-block d-none">Entrées Libres <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_credit_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_credit"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Retours Marchandises</span>
                                  <span class="d-sm-block d-none">Retours Marchandises <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_credit_sales_return_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_credit_sales_return"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Transferts Entants</span>
                                  <span class="d-sm-block d-none">Transferts Entants <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_transfer_in_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th>ORIGINE</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_transfer_in"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td>{{ item.warehouse_name }}</td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Virements Entants</span>
                                  <span class="d-sm-block d-none">Virements Entants <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_transformation_in_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_transformation_in"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Ajustements Entants</span>
                                  <span class="d-sm-block d-none">Ajustements Entants <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_adjust_in_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_adjust_in"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Sorties Libres</span>
                                  <span class="d-sm-block d-none">Sorties Libres  <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_debit_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_debit"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Ventes Marchandises</span>
                                  <span class="d-sm-block d-none">Ventes Marchandises <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_debit_sales_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_debit_sales"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Transferts Sortants</span>
                                  <span class="d-sm-block d-none">Transferts Sortants <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_transfer_out_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th>DESTINATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_transfer_out"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td>{{ item.destination_warehouse_name }}</td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Virements Sortants</span>
                                  <span class="d-sm-block d-none">Virements Sortants <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_transformation_out_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_transformation_out"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Ajustements Sortants</span>
                                  <span class="d-sm-block d-none">Ajustements Sortants <span
                                      class="badge badge-warning">{{
                                      queryApiData.table_view_products_stock_adjust_out_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-striped m-b-0">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>REF ARTICLE</th>
                                      <th>DESIGNATION</th>
                                      <th class="text-center">QUANTITE</th>
                                      <th class="text-right">MOTIF</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in queryApiData.table_view_products_stock_adjust_out"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td><b>{{ item.erp_code }}</b></td>
                                      <td><b>{{ item.name }}</b></td>
                                      <td class="text-center"><b>{{ item.total_quantity|formatDecimalNumber }}</b></td>
                                      <td class="text-right">{{ item.group_name }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                            </b-tabs>
                            <h3 class="m-t-10"><i class="fa fa-arrow-circle-right text-orange"></i> Documents</h3>
                            <b-tabs nav-class="nav-tabs-inverse" nav-wrapper-class="nav nav-tabs">
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Entrées Libres</span>
                                  <span class="d-sm-block d-none">Entrées Libres <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_credit_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_credit"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Retours Marchandises</span>
                                  <span class="d-sm-block d-none">Retours Marchandises <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_credit_sales_return_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_credit_sales_return"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Transferts Entants</span>
                                  <span class="d-sm-block d-none">Transferts Entants <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_transfers_in_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">ORIGINE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_transfers_in"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.warehouse_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Virements Entants</span>
                                  <span class="d-sm-block d-none">Virements Entants <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_transformations_in_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_transformations_in"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Ajustements Entants</span>
                                  <span class="d-sm-block d-none">Ajustements Entants <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_stock_adjust_in_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_stock_adjust_in"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Sorties Libres</span>
                                  <span class="d-sm-block d-none">Sorties Libres <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_debit_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_debit"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Ventes Marchandises</span>
                                  <span class="d-sm-block d-none">Ventes Marchandises <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_debit_sales_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_debit_sales"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Transferts Sortants</span>
                                  <span class="d-sm-block d-none">Transferts Sortants  <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_transfers_out_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">DESTINATION</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_transfers_out"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.destination_warehouse_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Virements Sortants</span>
                                  <span class="d-sm-block d-none">Virements Sortants  <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_transformations_out_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_transformations_out"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                              <b-tab>
                                <template slot="title">
                                  <span class="d-sm-none">Ajustements Sortants</span>
                                  <span class="d-sm-block d-none">Ajustements Sortants  <span
                                      class="badge badge-warning">{{
                                      queryApiData.stock_order_documents_stock_adjust_out_count
                                    }}</span></span>
                                </template>
                                <div class="table-responsive">
                                  <table class="table table-invoice">
                                    <thead>
                                    <tr>
                                      <th>#</th>
                                      <th class="text-left">DOCUMENT</th>
                                      <th class="text-left">DATE</th>
                                      <th class="text-left">TYPE</th>
                                      <th class="text-left">FAMILLE</th>
                                      <th class="text-left">INITIÉ PAR</th>
                                      <th class="text-left">VALIDÉ PAR</th>
                                      <th class="text-right">ARTICLES</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(related_stock_order,index) in queryApiData.stock_order_documents_stock_adjust_out"
                                        :key="index">
                                      <td><b>{{ index + 1 }}</b></td>
                                      <td class="text-left"><b><a href="javascript:;"
                                                                  @click="showStockOrderItem(related_stock_order.id)">{{
                                          related_stock_order.server_side_code
                                        }}</a></b>
                                      </td>
                                      <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                      <td class="text-left">{{ related_stock_order.type_name }}</td>
                                      <td class="text-left">{{ related_stock_order.group_name }}</td>
                                      <td class="text-left">{{ related_stock_order.seller_name }}</td>
                                      <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                      <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </b-tab>
                            </b-tabs>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body>
                        <b-card-header header-tag="header" class="card-header text-black pointer-cursor"
                                       v-b-toggle.accordion2>
                          <h2><i class="fa fa-arrow-circle-down text-orange"></i> Inventaires</h2>
                        </b-card-header>
                        <b-collapse id="accordion2" accordion="my-accordion">
                          <b-card-body>
                            <h3 class="m-t-10"><i class="fa fa-arrow-circle-right text-orange"></i> Inventaires
                              Infomatifs
                            </h3>
                            <div class="table-responsive">
                              <table class="table table-invoice">
                                <thead>
                                <tr>
                                  <th>#</th>
                                  <th class="text-left">DOCUMENT</th>
                                  <th class="text-left">DATE</th>
                                  <th class="text-left">TYPE</th>
                                  <th class="text-left">INITIÉ PAR</th>
                                  <th class="text-left">VALIDÉ PAR</th>
                                  <th class="text-right">ARTICLES</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(related_stock_order,index) in queryApiData.informative_inventory_documents"
                                    :key="index">
                                  <td><b>{{ index + 1 }}</b></td>
                                  <td class="text-left"><b><a href="javascript:;"
                                                              @click="showInventoryItem(related_stock_order.id)">{{
                                      related_stock_order.server_side_code
                                    }}</a></b>
                                  </td>
                                  <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                  <td><span class="label"
                                            :class="{'label-danger':related_stock_order.type === 'CORRECTIVE','label-primary':related_stock_order.type === 'INFORMATIVE'}">{{
                                      related_stock_order.type_name
                                    }}</span>
                                  </td>
                                  <td class="text-left">{{ related_stock_order.auditor_name }}</td>
                                  <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                  <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                            <h3 class="m-t-10"><i class="fa fa-arrow-circle-right text-orange"></i> Inventaires
                              Correctifs
                            </h3>
                            <div class="table-responsive">
                              <table class="table table-invoice">
                                <thead>
                                <tr>
                                  <th>#</th>
                                  <th class="text-left">DOCUMENT</th>
                                  <th class="text-left">DATE</th>
                                  <th class="text-left">TYPE</th>
                                  <th class="text-left">INITIÉ PAR</th>
                                  <th class="text-left">VALIDÉ PAR</th>
                                  <th class="text-right">ARTICLES</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(related_stock_order,index) in queryApiData.corrective_inventory_documents"
                                    :key="index">
                                  <td><b>{{ index + 1 }}</b></td>
                                  <td class="text-left"><b><a href="javascript:;"
                                                              @click="showInventoryItem(related_stock_order.id)">{{
                                      related_stock_order.server_side_code
                                    }}</a></b>
                                  </td>
                                  <td class="text-left">{{ related_stock_order.formatted_creation_date }}</td>
                                  <td><span class="label"
                                            :class="{'label-danger':related_stock_order.type === 'CORRECTIVE','label-primary':related_stock_order.type === 'INFORMATIVE'}">{{
                                      related_stock_order.type_name
                                    }}</span>
                                  </td>
                                  <td class="text-left">{{ related_stock_order.auditor_name }}</td>
                                  <td class="text-left">{{ related_stock_order.approved_by_name }}</td>
                                  <td class="text-right"><b>{{ related_stock_order.items_count|formatNumber }}</b>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                  <div class="invoice-footer">
                    <p class="text-center m-b-5 f-w-600">
                      MERCI DE VOTRE FIDELITE
                    </p>
                    <p class="text-center">
                      <span class="m-r-10"><i class="fa fa-fw fa-lg fa-globe"></i> {{
                          queryApiData.company_website
                        }}</span>
                      <span class="m-r-10"><i
                          class="fa fa-fw fa-lg fa-phone-volume"></i> T:{{ queryApiData.company_phone }}</span>
                      <span class="m-r-10"><i
                          class="fa fa-fw fa-lg fa-envelope"></i> {{ queryApiData.company_email }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-else>
            <div class="panel">
              <div class="panel-body">
                <div class="invoice">
                  <div class="invoice-company">

                    <h3 class="page-header">Mouvements de stock &amp; Inventaires.<br/>
                      <small class="lead">Dans cette section, vous pouvez suivre les mouvements de stock et consulter
                        les rapports
                        d'inventaire d'un emplacement donné sur la période selectionnée.
                      </small></h3>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Dialogs -->
        <b-modal
            centered
            hide-header
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            id="formModal"
            title="Modal Title"
            size="md"
            @show="()=>{
              this.queryApiDataErrorMessage = null;
            }"
            @hidden="()=>{}">

          <div class="row ">
            <p class="col-12 text-right">
              <a href="javascript:;" class="btn btn-danger" @click="$bvModal.hide('formModal')"><i
                  class="fa fa-times fa-fw fa-lg"></i></a>
            </p>
          </div>

          <h1 class="page-header">Choisir un emplacement <small class="lead"></small></h1>
          <div class="row" v-if="queryApiDataIsLoading">
            <div class="col-12 m-b-10">
              <small class="lead text-warning"><i class="fas fa-spinner fa-pulse"></i> Chargement en
                cours...</small><br/>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12" v-if="queryApiDataErrorMessage != null">
              <div class="alert alert-danger">
                {{ queryApiDataErrorMessage }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <form
                  @submit.prevent="queryData">
                <div class="form-group row">
                  <div class="col-12">
                    <label>Choisir un emplacement</label>
                    <v-select label="name" :options="pageIndexApiData.warehouses"
                              :reduce="item => item.id"
                              v-model="form.warehouse_id"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <label>Définir la période</label>
                    <date-range-picker ref="picker" class="btn btn-white btn-block text-right"
                                       opens="right"
                                       :ranges="dateRanges"
                                       :locale-data="{
                                                      format: 'dd-mm-yyyy',
                                                      separator: ' - ',
                                                      applyLabel: 'Appliquer',
                                                      cancelLabel: 'Annuler',
                                                      weekLabel: 'S',
                                                      customRangeLabel: 'Plage Perso.',
                                                      daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                                                      monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                                                      firstDay: 1
                                                    }"
                                       :singleDatePicker="false"
                                       :timePicker="false"
                                       :timePicker24Hour="true"
                                       :showWeekNumbers="false"
                                       :showDropdowns="false"
                                       :autoApply="true"
                                       v-model="form.date_range"
                                       @update="()=>{}"
                                       :linkedCalendars="false">
                      <template v-slot:input="picker" class="text-right">
                        {{ picker.startDate | formatJSDate }} - {{ picker.endDate | formatJSDate }}
                        <i class="fa fa-calendar fa-fw fa-lg text-dark"></i>
                      </template>
                    </date-range-picker>
                  </div>
                </div>
                <!--
                <div class="form-group row">
                  <div class="col-12">
                    <div class="checkbox checkbox-css checkbox-inline">
                      <input type="checkbox" id="pdf" v-model="form.to_pdf"/>
                      <label for="pdf"><i class="fas fa-download text-warning"></i>
                        Télécharger au format PDF</label>
                    </div>
                  </div>
                </div>
                -->
                <div class="form-group row">
                  <div class="col-12 text-right">
                    <button :disabled="queryApiDataIsLoading" type="submit" class="btn btn-dark">
                      <i class="fas fa-spinner fa-spin" v-if="queryApiDataIsLoading"></i>
                      <i class="fas fa-filter" v-else></i> Filtrer
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!--
          <div class="row ">
            <p class="col-12 text-right">
              <a href="javascript:;" class="btn btn-white m-r-5" @click="()=>{}"><i class="fa fa-comment fa-fw fa-lg"></i></a>
              <a href="javascript:;" class="btn btn-white m-r-5" @click="()=>{}"><i class="fa fa-cogs fa-fw fa-lg"></i></a>
            </p>
          </div>
          -->
        </b-modal>

        <b-modal
            centered
            hide-header
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            id="stockOrderModal"
            title="Modal Title"
            size="xl"
            @show="()=>{}"
            @hidden="()=>{}">

          <div class="row ">
            <p class="col-12 text-right">
              <a href="javascript:;" class="btn btn-danger" @click="$bvModal.hide('stockOrderModal')"><i
                  class="fa fa-times fa-fw fa-lg"></i></a>
            </p>
          </div>

          <stock-order-component :itemId="selectedStockOrderId"/>

          <!--
          <div class="row ">
            <p class="col-12 text-right">
              <a href="javascript:;" class="btn btn-white m-r-5" @click="()=>{}"><i class="fa fa-comment fa-fw fa-lg"></i></a>
              <a href="javascript:;" class="btn btn-white m-r-5" @click="()=>{}"><i class="fa fa-cogs fa-fw fa-lg"></i></a>
            </p>
          </div>
          -->
        </b-modal>
        <b-modal
            centered
            hide-header
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            id="inventoryModal"
            title="Modal Title"
            size="xl"
            @show="()=>{}"
            @hidden="()=>{}">

          <div class="row ">
            <p class="col-12 text-right">
              <a href="javascript:;" class="btn btn-danger" @click="$bvModal.hide('inventoryModal')"><i
                  class="fa fa-times fa-fw fa-lg"></i></a>
            </p>
          </div>

          <inventory-component :itemId="selectedInventoryId"/>

          <!--
          <div class="row ">
            <p class="col-12 text-right">
              <a href="javascript:;" class="btn btn-white m-r-5" @click="()=>{}"><i class="fa fa-comment fa-fw fa-lg"></i></a>
              <a href="javascript:;" class="btn btn-white m-r-5" @click="()=>{}"><i class="fa fa-cogs fa-fw fa-lg"></i></a>
            </p>
          </div>
          -->
        </b-modal>
      </div>
    </div>
    <div class="panel-loader" v-else><span class="spinner-small"></span></div>
  </div>
</template>


<script>
import pageApi from '../../store/api/monitoring/warehouse-periodic-stock-report-dashboard-page-api'
import LocalStorage from "../../store/local-storage";
import CompanyLicenceComponent from '../../components/app/base/CompanyLicenceComponent.vue'
import InventoryComponent from "@/components/app/InventoryComponent";
import StockOrderComponent from "@/components/app/StockOrderComponent";

export default {
  name: 'warehouse-periodic-stock-report-dashboard-page-component',
  components: {
    StockOrderComponent,
    InventoryComponent,
    CompanyLicenceComponent,
  },
  props: {},
  watch: {},
  computed: {},
  methods: {
    //Initialization Methods
    loadPageScripts() {
    },

    formatDateInput (value) {
      if (value) {
        return window.moment(String(value)).format(window.appDefaultDisplayDateTimeFormat)
      }
      return null;
    },

    //
    showStockOrderItem(id) {
      this.selectedStockOrderId = id;
      this.$bvModal.show('stockOrderModal');
    },

    showInventoryItem(id) {
      //
      this.selectedInventoryId = id;
      this.$bvModal.show('inventoryModal');
    },


    //Other Methods
    async getPageIndexApiData() {
      this.pageIndexApiDataIsLoading = true;
      this.pageIndexApiDataErrorMessage = null;
      try {
        const response = await pageApi.getIndexData();
        //console.log(response);
        this.pageIndexApiData = response.data;
        this.pageIndexApiDataIsLoading = false;
        this.pageIndexApiDataErrorMessage = null;
      } catch (error) {
        if (error.response) {
          //Server responded with a status code that is NOT in the HTTP 200 range
          //console.log("Headers", error.response.headers);
          //console.log("Status Code", error.response.status);
          //console.log("Response Data", error.response.data);
          if (error.response.status === 401 || error.response.status === 403 || error.response.status === 419) {
            this.pageIndexApiDataIsLoading = false;
            this.pageIndexApiDataErrorMessage = error.response.data.message;
            LocalStorage.clearSessionData();
            this.$router.push('login');
          } else {
            this.pageIndexApiDataIsLoading = false;
            this.pageIndexApiDataErrorMessage = error.response.data.message;
            //
            this.$swal({
              icon: 'error',//'info','success','warning','error','question',
              toast: true,
              position: 'bottom-end',
              timer: 3000,
              showConfirmButton: false,
              title: 'HTTP ' + error.response.status,
              text: error.response.data.message,
            })
          }
        } else {
          this.pageIndexApiDataIsLoading = false;
          this.pageIndexApiDataErrorMessage = error.message;
          //
          this.$swal({
            icon: 'error',//'info','success','warning','error','question',
            toast: true,
            position: 'bottom-end',
            timer: 3000,
            showConfirmButton: false,
            //title: error.message
            text: error.message,
          })
        }
      }
    },

    async queryData() {
      this.queryApiDataIsLoading = true;
      this.queryApiDataErrorMessage = null;
      this.queryApiDataValidationErrors = [];
      try {
        const response = await pageApi.queryData({
          warehouse_id: this.form.warehouse_id,
          date_from: this.formatDateInput(this.form.date_range.startDate),
          date_to: this.formatDateInput(this.form.date_range.endDate),
          to_pdf: this.form.to_pdf
        });
        //console.log(response);
        this.queryApiData = response.data;
        this.queryApiDataIsLoading = false;
        this.queryApiDataErrorMessage = null;
        this.queryApiDataValidationErrors = [];

        this.$bvModal.hide('formModal');

      } catch (error) {
        if (error.response) {
          //Server responded with a status code that is NOT in the HTTP 200 range
          //console.log("Headers", error.response.headers);
          //console.log("Status Code", error.response.status);
          //console.log("Response Data", error.response.data);
          this.queryApiDataIsLoading = false;
          this.queryApiDataErrorMessage = error.response.data.message;
          if (error.response.status === 422) {
            this.queryApiDataValidationErrors = error.response.data.errors;
          } else {
            this.queryApiDataValidationErrors = [];
          }
        } else {
          this.queryApiDataIsLoading = false;
          this.queryApiDataErrorMessage = error.message;
          this.queryApiDataValidationErrors = [];
        }
      }
    },
  },
  data: function () {

    let today = new Date()
    today.setHours(0, 0, 0, 0)
    let todayEnd = new Date()
    todayEnd.setHours(11, 59, 59, 999);
    let yesterdayStart = new Date()
    yesterdayStart.setDate(today.getDate() - 1)
    yesterdayStart.setHours(0, 0, 0, 0);
    let yesterdayEnd = new Date()
    yesterdayEnd.setDate(today.getDate() - 1)
    yesterdayEnd.setHours(11, 59, 59, 999);
    let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);


    return {
      appName: window.appConfig.appName,
      appCurrency: window.appConfig.appCurrency,
      intervalId01: 0,

      selectedStockOrderId: null,
      selectedInventoryId: null,

      form: {
        warehouse_id: null,
        date_range: {
          startDate: null,
          endDate: null,
        },
        to_pdf: false,
      },

      dateRanges: {
        "Aujourd'hui": [today, todayEnd],
        "Hier": [yesterdayStart, yesterdayEnd],
        "Mois en cours": [thisMonthStart, thisMonthEnd],
        "Mois dernier": [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
        ],
        "Année en cours": [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
        ],
        "Année dernière": [
          new Date(today.getFullYear() - 1, 0, 1),
          new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)
        ],
      },

      //API Data
      //
      pageIndexApiData: null,
      pageIndexApiDataIsLoading: false,
      pageIndexApiDataErrorMessage: null,

      queryApiData: null,
      queryApiDataIsLoading: false,
      queryApiDataErrorMessage: null,
      queryApiDataValidationErrors: [],

      //
    };
  },
  created: function () {
    this.getPageIndexApiData();
  },
  mounted: function () {
    this.loadPageScripts();
  },
  beforeDestroy: function () {
  },
}
</script>
